import { render, staticRenderFns } from "./panel_jiyang.vue?vue&type=template&id=bb83514e&scoped=true&"
import script from "./panel_jiyang.vue?vue&type=script&lang=js&"
export * from "./panel_jiyang.vue?vue&type=script&lang=js&"
import style0 from "./panel_jiyang.vue?vue&type=style&index=0&id=bb83514e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb83514e",
  null
  
)

export default component.exports